import { createRouter, createWebHistory } from "vue-router";
import { com_isSubscriptionExpired } from "@/utils/globalFunctions";

const routes = [
  {
    name: "guest",
    path: "/login",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: [
      {
        path: "",
        name: "login",
        component: () =>
          import(/*webpackChunck: "login" */ "../pages/Auth/LoginView.vue"),
        meta: {
          title: `Log In`,
        },
      },
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: () =>
          import(
            /*webpackChunck: "forgot-password" */ "../pages/Auth/ForgotPasswordView.vue"
          ),
        meta: {
          title: `Forgot Password`,
        },
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import(/*webpackChunck: "sign-up" */ "../pages/Auth/SignUpView.vue"),
        meta: {
          title: `Sign Up`,
        },
      },
      {
        path: "/checkout",
        name: "checkout",
        component: () =>
          import(/*webpackChunck: "checkout" */ "../pages/CheckOutView.vue"),
        meta: {
          title: `Checkout`,
        },
      },
       {
        path: "/success-payment",
        name: "success-payment",
        component: () =>
          import(
            /*webpackChunck: "success-payment" */ "../pages/SuccessPayment.vue"
          ),
        meta: {
          title: `Success Payment`,
        },
      },
{
        path: "/failed-payment",
        name: "failed-payment",
        component: () =>
          import(
            /*webpackChunck: "failed-payment" */ "../pages/FailedPayment.vue"
          ),
        meta: {
          title: `Failed Payment`,
        },
      },
      
      {
        path: "/pagenotfound",
        name: "pagesnotfound",
        component: () => import("../components/404NotFound.vue"),
      },
    ],
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/Default.vue"),
    meta: {
      middleware: "auth",
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "home" */ "../pages/HomeView.vue"),
        meta: {
          title: `Dashboard`,
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: () =>
          import(/* webpackChunkName: "profile" */ "../pages/ProfileView.vue"),
        meta: {
          title: `Profile`,
        },
      },
      {
        path: "/lobby-server",
        name: "lobby-server",
        component: () =>
          import(/* webpackChunkName: "lobby-server" */ "../pages/LobbyServerView.vue"),
        meta: {
          title: `Lobby Server`,
        },
      },
    ],
  },
  // Catch-all route for 404 - must be last
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: [
      {
        path: "",
        component: () => import("../components/404NotFound.vue"),
        meta: {
          title: "404 - Page Not Found",
        },
      },
    ],
  },
];

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt_token") == null) {
      next({
        name: "login",
      });
    } else {
      // Check if subscription is expired (both free and premium)
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          // Check if subscription is expired
          const { isExpired } = com_isSubscriptionExpired(user);

          if (isExpired) {
            // Only allow navigation to home, profile, and checkout routes
            if (
              to.name !== "home" &&
              to.name !== "profile" &&
              to.name !== "checkout" &&
              to.name !== "lobby-server"
            ) {
              next({
                name: "home",
              });
              return;
            }
          }
        } catch (error) {
          console.error("Error parsing user data:", error);
        }
      }
      next();
    }
  } else {
    if (to.name == "login") {
      if (localStorage.getItem("jwt_token") == null) {
        next();
      } else {
        next({
          name: "home",
        });
      }
    } else {
      next();
    }
  }
});

export default router;
